import { DIRECTIVE_PENDING_ALERT_DAYS } from '../constants/projectOptions';

/**
 * Rappel « A evaluer depuis trop longtemps », calcule cote app.
 *
 * Une directive en retard : outcome 'pending' depuis N jours ou plus
 * (N = DIRECTIVE_PENDING_ALERT_DAYS), comptes depuis date_directive.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

// date_directive est une date nue (YYYY-MM-DD) : lue a midi local, comme partout
// dans l'app, pour qu'aucun fuseau ne la fasse changer de jour.
const toLocalNoon = (value) => {
  if (!value) return null;
  const d = new Date(`${String(value)?.slice(0, 10)}T12:00:00`);
  return Number.isNaN(d?.getTime()) ? null : d;
};

/** Jours ecoules depuis la reception d'une directive « A evaluer » ; null sinon. */
export const pendingDays = (directive, today = new Date()) => {
  if ((directive?.outcome || 'pending') !== 'pending') return null;
  const received = toLocalNoon(directive?.date_directive);
  if (!received) return null;
  const now = new Date(today);
  now.setHours(12, 0, 0, 0);
  return Math.floor((now - received) / DAY_MS);
};

/** Vrai si la directive est « A evaluer » depuis N jours ou plus. */
export const isPendingOverdue = (directive, today = new Date()) => {
  const days = pendingDays(directive, today);
  return days != null && days >= DIRECTIVE_PENDING_ALERT_DAYS;
};
